export default __webpack_public_path__ + "static/media/timer.a473a497.svg";